<template>
  <div id="direct-contact-update" v-if="detail.id !== ''" @click="cancelLookup()">
    <div class="expanded row">
      <div class="small-12 medium-5 columns">
        <div class="collapse row">
          <div class="column">
            <div class="row">
              <div class="column shrink">
                <label for="registrar" class="text-right middle">{{ 'Registrar'|t }} </label>
              </div>
              <div class="column">
                <AutoCompleteRegistrar v-model="registrar" :email="true" :value="registrar" id="registrar" name="registrar" classes="text-center"></AutoCompleteRegistrar>
              </div>
            </div>
          </div>
          <div class="column shrink">
            <button class="medium success button" @click="submitRegistrar">{{ 'Submit'|t }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api';
  import AutoCompleteRegistrar from '@/components/AutoCompleteRegistrar';

  export default {
    name: 'DirectContactUpdateForm',
    components: { AutoCompleteRegistrar },
    props: {
      id: {
        type: String,
        required: true,
      },
    },
    created() {
      let self = this;
      api.viewContact(
        {contact_id: this.id},
        data => {
          self.detail = data;
        }
      );
    },
    data() {
      return {
        detail: {
          id: "",
          registrar: "",
        },
        registrar: "",
        lookup: {
          delay: null,
          name: null,
          results: [],
          working: false
        }
      }
    },
    methods: {
      submitRegistrar() {
        let request = {
          contact_id: this.detail.id,
          registrar_email: this.registrar
        };

        api.changeContactRegistrar(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Contact has been updated."
            }, {root: true});
          }
        );
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/contact/UpdateDirect.vue